import { CHANGE_ACK_TYPES } from 'cpool-constants';
import { schemaId } from 'cpool-schemas';
// import type { ValueOf } from 'cpool-utils';
import { z } from 'zod';

// export type UnacknowledgedChangesTableSchema = {
//     changes: Array<{ id: string; type: ValueOf<typeof CHANGE_ACK_TYPES> }> | null;
//     id: string;
//     status: string;
//     userIds: string[];
// };

export const UnacknowledgedChangesTableDefinitionZod = z.object({
    changes: z
        .array(
            z.object({
                id: schemaId,
                type: z.nativeEnum(CHANGE_ACK_TYPES),
            }),
        )
        .nullable(),
    id: schemaId,
    status: z.string(),
    userIds: z.array(schemaId),
});

export type UnacknowledgedChangesTableSchema = z.infer<typeof UnacknowledgedChangesTableDefinitionZod>;
